import React from 'react';
import Link from 'next/link';
import { defineMessages } from 'react-intl';

import { ROUTES } from 'src/common/routes';

export const ErrorHeaderMessages = defineMessages({
  network: {
    id: 'sign-up-form.error-header.network',
    defaultMessage: 'Network error.',
  },
  emailTaken: {
    id: 'sign-up-form.error-header.email-taken',
    defaultMessage: 'Email already taken.',
  },
  unknown: {
    id: 'sign-up-form.error-header.unknown',
    defaultMessage: 'Unknown error.',
  },
});

export const ErrorBodyMessages = defineMessages({
  network: {
    id: 'sign-up-form.error-body.network',
    defaultMessage: "Please check if you're connected to the Internet.",
  },
  emailTaken: {
    id: 'sign-up-form.error-body.email-taken',
    defaultMessage: 'That email address has already been registered.',
  },
  unknown: {
    id: 'sign-up-form.error-body.unknown',
    defaultMessage:
      'We have encountered an unknown problem. Our engineers have been notified.',
  },
});

export const EmployerLoginMessages = defineMessages({
  helperText: {
    id: 'employers-login',
    defaultMessage: "If you're an employer, visit { link } instead",
  },
  link: {
    id: 'employers-login.link',
    defaultMessage: 'this page',
  },
});

export const LoginLink = (...chunks: React.ReactNode[]) => (
  <Link href={`/${ROUTES.login}`}>{chunks}</Link>
);

export const ForgotPasswordLink = (...chunks: React.ReactNode[]) => (
  <Link href={`/${ROUTES.forgotPassword}`}>{chunks}</Link>
);
